import {isValidHttpUrl} from "./src/services/helpers/isValidHttpUrl";
if (Platform.OS === 'web') {
    import('./app.css');
}

if (typeof ErrorUtils === 'undefined') {
    global.ErrorUtils = {
        setGlobalHandler: () => {},
        reportError: console.error,
    };
}

if (!__DEV__ && !isWEB()) {
  ErrorUtils.setGlobalHandler((error, isFatal) => {
    // Handle the error, e.g., log it or display a notification
    console.error('Global error handler', error, isFatal);
  });
}

// DO NOT REMOVE THESE IMPORTS - they are used to initialize the app listeners
import * as destroyInstance from "./src/services/events/destroyInstance";
import * as restartApp from "./src/services/events/restartApp";

import {ImageBackground, KeyboardAvoidingView, LogBox, Platform} from 'react-native';
import React, {useEffect, useState} from 'react';
import {Provider, useSelector} from "react-redux";
import {setupGlobals} from './src/services/setGlobals';
import {checkAndApplyUpdates} from "./src/services/expoUpdates";
import ErrorBoundary from "./src/components/ErrorBoundry";
import { RootSiblingParent } from 'react-native-root-siblings';
import { Store } from "./src/reducers/store";
import Wrapper from "./Wrapper";
import { initializeApp } from './src/services/initialization/initializeApp';
import useInterval from "./src/services/hooks/useInterval";
import {getConfig} from "./src/reducers/configSlice";
import {isIOS, isWEB} from "./src/services/helpers/getPlatformType";
import {useBackButtonHandler} from "./src/services/hooks/useBackButtonHandler";
import { initializePrivacyProtection, cleanupPrivacyProtection } from './src/services/privacy/privacyProtectionService';
import { initializeRaspProtection, cleanupRaspProtection } from './src/services/rasp/raspService';
import PrivacyBlur from './src/components/PrivacyBlur';

// Import test utilities in development mode
if (__DEV__) {
    import('./src/services/privacy/privacyTestUtils');
}

LogBox.ignoreAllLogs(true);
setupGlobals()

const AppWrapper = () => {
    const config = useSelector(getConfig);
    const [backgroundImage, setBackgroundImage] = useState(config.background_image && isValidHttpUrl(config.background_image) ? {uri: config.background_image} : require("./assets/images/meeting-room-display-default.png"));
    const [backgroundColor, setBackgroundColor] = useState(config.background_color ? config.background_color : 'rgba(0, 0, 0, 0.5)');

    useEffect(() => {
        setBackgroundImage(config.background_image && isValidHttpUrl(config.background_image) ? {uri: config.background_image} : require("./assets/images/meeting-room-display-default.png"))
        setBackgroundColor(config.background_color ? config.background_color : 'rgba(0, 0, 0, 0.5)')
    }, [config]);

    return (
        <RootSiblingParent>
            <KeyboardAvoidingView behavior={isIOS() ? 'padding' : null} keyboardVerticalOffset={Platform.select({ ios: 0, android: 500 })} style={{ flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                <ImageBackground resizeMode='cover' source={backgroundImage} style={{ width: '100%', height: '100%'}}>
                    <Wrapper backgroundColor={backgroundColor} />
                </ImageBackground>
                <PrivacyBlur />
            </KeyboardAvoidingView>
        </RootSiblingParent>
    );
};


const App = () => {
    useEffect(() => {
        (async () => {
            await initializeApp(); // Call the initialization function once on app start
            await useBackButtonHandler() // Handle the back button - Android only - must be sut un inside a component

            // Initialize privacy protection service
            initializePrivacyProtection();

            // Initialize RASP (Runtime Application Self-Protection) service
            await initializeRaspProtection();
        })();

        // Cleanup services on unmount
        return () => {
            cleanupPrivacyProtection();
            cleanupRaspProtection();
        };
    }, []);

    useInterval(async () => {
        await checkAndApplyUpdates(false, true);
    }, 30 * 60 * 1000); // 30 minutes in milliseconds

  return (
      <ErrorBoundary>
        <Provider store={Store}>
            <AppWrapper />
        </Provider>
      </ErrorBoundary>
  );
}

export default App
